const linksOtherData = [
  {
    link: 'https://proglib.io/p/becoming-fullstack-dev-in-2017/',
    name: 'Becoming-fullstack',
  },
  {
      "name":"RPG на JavaScript",
      "link":"https://habrahabr.ru/company/edison/blog/316072/"
  },
  {
      "name":"Resursable",
      "link":"https://max-im.github.io/pages/resursable/"
  },
  {
      "name":"Frontend blog",
      "link":"https://m.habrahabr.ru/company/zfort/blog/"
  }
];

export default linksOtherData;



// WEBPACK FOOTER //
// ./src/assets/linksOtherData.js